<template>
  <div class="tilte-list">
    <img :src="require('@/assets/daping/title-long-mini.svg')" class="title-long" v-if="imgShort == '0'"/>
    <img :src="require('@/assets/daping/title-short.svg')" class="title-short" v-if="imgShort == '1'"/>
    <div class="title-name">
      {{ titleName }}
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  props: {
    titleName: {
      type: String,
      default: "",
    },
    imgShort: {
      type: String,
      default: "0",
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.tilte-list {
  position: relative;
  .title-long {
    width: 727px;
  }
  .title-short {
    width: 732px;
  }
  .title-name {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 27px;
    color: #f3f8ff;
    line-height: 37px;
    text-shadow:  0px 4px 8px rgba(3, 9, 24, 0.2);
    text-align: left;
    font-style: normal;
    background: linear-gradient(180deg, #ffffff 0%, #5bacef 100%);
    color: transparent;
    /* 使用背景渐变填充文字 */
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow:  0px 4px 8px rgba(3, 9, 24, 0.2);

    position: absolute;
    left: 50px;
    top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/title.vue